import { BaseService } from './../../core/services/base.service';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { EmailResendEmailDialogComponent } from '../email-resend-email-dialog/email-resend-email-dialog.component';

@Component({
  selector: 'app-email-failed-delivery-action-dialog',
  templateUrl: './email-failed-delivery-action-dialog.component.html',
  styleUrls: ['./email-failed-delivery-action-dialog.component.scss']
})
export class EmailFailedDeliveryActionDialogComponent implements OnInit {
  form!: FormGroup;
  config!: any;

  constructor(
    public dialogRef: MatDialogRef<EmailFailedDeliveryActionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private baseService: BaseService,
    private dialog: MatDialog
  ) {
    console.log('dialog data', data);
    this.form = fb.group({
      customerEmailEventId: [null, Validators.compose([Validators.required])],
      orderType: [null, Validators.compose([])],
      orderNumber: [null, Validators.compose([])],
      receipientEmail: [null, Validators.compose([])],
      soEmail: [null, Validators.compose([])],
      arCustomerEmail: [null, Validators.compose([])],
      emailType: [null, Validators.compose([])],
      sysproBranch: [null, Validators.compose([])],
      sysproSalesperson: [null, Validators.compose([])],
      salespersonNotes: [
        null,
        Validators.compose([Validators.required, Validators.maxLength(200)])
      ],
      actionCategoryId: [null, Validators.compose([])]
    });

    this.form.controls['orderType'].disable();
    this.form.controls['orderNumber'].disable();
    this.form.controls['receipientEmail'].disable();
    this.form.controls['soEmail'].disable();
    this.form.controls['arCustomerEmail'].disable();
    this.form.controls['emailType'].disable();
    this.form.controls['sysproBranch'].disable();
    this.form.controls['sysproSalesperson'].disable();
  }

  ngOnInit() {
    this.baseService
      .executeCommand<any>('portal_todo_customer_failed_email_action_config', {
        customerEmailEventId: this.data.callbackOrSurveyId,
      })
      .subscribe((response) => {
        if (response.responseCode === 0) {
          this.form.patchValue(response.data.initialFormValue);
          this.form.updateValueAndValidity();
          this.config = response.data;
        } else {
          this.dialogRef.close(undefined);
        }
      });
  }

  save(complete: boolean) {
    const fromValue = this.form.getRawValue();

    if (complete) {
      const ref = this.dialog.open(EmailResendEmailDialogComponent);
      ref.afterClosed().subscribe(dialogResponse => {
        this.baseService
        .executeCommand<any>('portal_todo_customer_failed_email_modify', Object.assign({complete: complete, sendEmail: dialogResponse}, fromValue))
        .subscribe((response) => {
          if (response.responseCode === 0) {
            this.dialogRef.close(true);
          } else {
          }
        });
      });
    } else {
      this.baseService
        .executeCommand<any>('portal_todo_customer_failed_email_modify', Object.assign({complete: complete, sendEmail: false}, fromValue))
        .subscribe((response) => {
          if (response.responseCode === 0) {
            this.dialogRef.close(true);
          } else {
          }
        });

    }
  }
}
